<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad">
                <!-- <div class="OwnersCard" v-for="item in list" :key="item" @click="openMeet(item)"> -->
                    <van-cell-group :border='false' v-for="item in list" :key="item" @click="openMeet(item)" >
                    <van-cell :value='item.completionDate' is-link :border='false'>
                        <template #title>
                            <span class="customTile">{{item.reqName}}</span>
                        </template>
                    </van-cell>
                    </van-cell-group>
                <!-- </div> -->
            </van-list>
        </van-pull-refresh>
        <div v-if="isShow2" style="margin-top:15px;font-size:14px;text-align:center;color:#e0e0e0">暂无数据</div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            isShow2:false,
            refreshing:false,
            error: false,
            loading:false,
            finished:false,
            list: [],
        }
    },
    methods:{
        onLoad(){
            let data={
                projectType:2,
                finish:1,
                pageNum:1,
                pageSize:100,
            }
            this.$postQuery('/weChatNotice/getWeChatReqList', data).then((response) => {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                // console.log(response)
                if(response.code==200){
                    this.list = response.data.list
                    if(this.list.length==0){
                        this.isShow2 = true
                    }
                    this.list.forEach((item)=>{
                        if(item.completionDate){
                            item.completionDate = item.completionDate.substring(0,10)
                        }
                    })
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    if (this.list.length >= response.data.list.length) {
                        this.finished = true;
                    }
                }
            })
            .catch(()=>{
                this.loading = false;
                this.error = true;
            })
        },
        onRefresh(){
            // 清空列表数据
            this.finished = false;
            //重新加载数据
            this.loading = true;
            this.onLoad();
        },
        openMeet(item){
            this.$router.push({
                path:'/EmergencyPublicity1',
                query:{
                    id:item.id,
                    thatName:item.reqName,
                    completionDate:item.completionDate
                }
            })
        }
    }
}
</script>

<style scoped>
.OwnersCard{
  margin:5px 12px;
  box-shadow: 0 8px 12px #ebedf0;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
}
.customTile{
  display:inline-block;
  width: 150px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
</style>